// Hintergrund-Bibliothek für Seasonal Themes
export const backgroundLibrary = {
  solid: {
    name: 'Einfarbig',
    icon: '🎨',
    items: [
      { id: 'solid-cream', type: 'solid', value: '#F5F5DC', name: 'Creme' },
      { id: 'solid-beige', type: 'solid', value: '#E8E0D5', name: 'Beige' },
      { id: 'solid-white', type: 'solid', value: '#FFFFFF', name: 'Weiß' },
      { id: 'solid-lightgray', type: 'solid', value: '#F5F5F5', name: 'Hellgrau' },
    ]
  },
  gradients: {
    name: 'Farbverläufe',
    icon: '🌈',
    items: [
      { 
        id: 'gradient-warm', 
        type: 'gradient', 
        value: 'linear-gradient(135deg, #FFF5E6 0%, #FFE4CC 100%)', 
        name: 'Warmer Sonnenaufgang',
        preview: 'linear-gradient(135deg, #FFF5E6 0%, #FFE4CC 100%)'
      },
      { 
        id: 'gradient-christmas', 
        type: 'gradient', 
        value: 'linear-gradient(135deg, #FFF5F5 0%, #FFE4E4 50%, #E8F5E8 100%)', 
        name: 'Weihnachtlich',
        preview: 'linear-gradient(135deg, #FFF5F5 0%, #FFE4E4 50%, #E8F5E8 100%)'
      },
      { 
        id: 'gradient-spring', 
        type: 'gradient', 
        value: 'linear-gradient(135deg, #FFFEF5 0%, #FFF0F5 50%, #F0FFF5 100%)', 
        name: 'Frühling',
        preview: 'linear-gradient(135deg, #FFFEF5 0%, #FFF0F5 50%, #F0FFF5 100%)'
      },
      { 
        id: 'gradient-summer', 
        type: 'gradient', 
        value: 'linear-gradient(135deg, #FFF9E6 0%, #E6F7FF 100%)', 
        name: 'Sommerfrische',
        preview: 'linear-gradient(135deg, #FFF9E6 0%, #E6F7FF 100%)'
      },
      { 
        id: 'gradient-autumn', 
        type: 'gradient', 
        value: 'linear-gradient(135deg, #FFF5E6 0%, #FFE8CC 50%, #FFD9B3 100%)', 
        name: 'Herbstfarben',
        preview: 'linear-gradient(135deg, #FFF5E6 0%, #FFE8CC 50%, #FFD9B3 100%)'
      },
      { 
        id: 'gradient-valentines', 
        type: 'gradient', 
        value: 'linear-gradient(135deg, #FFF0F5 0%, #FFE4EC 100%)', 
        name: 'Romantisch',
        preview: 'linear-gradient(135deg, #FFF0F5 0%, #FFE4EC 100%)'
      },
      { 
        id: 'gradient-elegant', 
        type: 'gradient', 
        value: 'linear-gradient(135deg, #F5F5F5 0%, #E8E8E8 100%)', 
        name: 'Elegant Grau',
        preview: 'linear-gradient(135deg, #F5F5F5 0%, #E8E8E8 100%)'
      },
    ]
  },
  patterns: {
    name: 'Muster & Texturen',
    icon: '🔲',
    items: [
      { 
        id: 'pattern-dots', 
        type: 'pattern', 
        value: 'radial-gradient(circle, #00000008 1px, transparent 1px)',
        size: '20px 20px',
        color: '#F5F5F5',
        name: 'Punkte',
        preview: 'radial-gradient(circle, #00000008 1px, transparent 1px)'
      },
      { 
        id: 'pattern-grid', 
        type: 'pattern', 
        value: 'linear-gradient(#00000008 1px, transparent 1px), linear-gradient(90deg, #00000008 1px, transparent 1px)',
        size: '20px 20px',
        color: '#FFFFFF',
        name: 'Gitter',
        preview: 'linear-gradient(#00000008 1px, transparent 1px), linear-gradient(90deg, #00000008 1px, transparent 1px)'
      },
      { 
        id: 'pattern-diagonal', 
        type: 'pattern', 
        value: 'repeating-linear-gradient(45deg, transparent, transparent 10px, #00000005 10px, #00000005 20px)',
        size: 'auto',
        color: '#F5F5F5',
        name: 'Diagonale Streifen',
        preview: 'repeating-linear-gradient(45deg, transparent, transparent 10px, #00000005 10px, #00000005 20px)'
      },
      { 
        id: 'pattern-waves', 
        type: 'pattern', 
        value: 'radial-gradient(ellipse at top, transparent 0%, transparent 40%, #00000005 40%, #00000005 60%, transparent 60%)',
        size: '100px 50px',
        color: '#E8E0D5',
        name: 'Wellen',
        preview: 'radial-gradient(ellipse at top, transparent 0%, transparent 40%, #00000005 40%, #00000005 60%, transparent 60%)'
      },
      { 
        id: 'pattern-snowflakes', 
        type: 'pattern', 
        value: 'radial-gradient(circle at 20% 30%, #FFFFFF20 1px, transparent 1px), radial-gradient(circle at 60% 70%, #FFFFFF30 2px, transparent 2px), radial-gradient(circle at 80% 20%, #FFFFFF20 1.5px, transparent 1.5px)',
        size: '100px 100px',
        color: '#E6F0FF',
        name: 'Schneeflocken',
        preview: 'radial-gradient(circle at 20% 30%, #FFFFFF20 1px, transparent 1px), radial-gradient(circle at 60% 70%, #FFFFFF30 2px, transparent 2px)'
      },
      { 
        id: 'pattern-hearts', 
        type: 'pattern', 
        value: 'radial-gradient(circle at 30% 40%, #FF69B420 2px, transparent 2px), radial-gradient(circle at 70% 60%, #FF69B415 1.5px, transparent 1.5px)',
        size: '60px 60px',
        color: '#FFF0F5',
        name: 'Herzchen',
        preview: 'radial-gradient(circle at 30% 40%, #FF69B420 2px, transparent 2px)'
      },
      { 
        id: 'pattern-leaves', 
        type: 'pattern', 
        value: 'radial-gradient(ellipse at 25% 35%, #8B451315 3px, transparent 3px), radial-gradient(ellipse at 75% 65%, #8B451310 2px, transparent 2px)',
        size: '80px 80px',
        color: '#FFF5E6',
        name: 'Blätter',
        preview: 'radial-gradient(ellipse at 25% 35%, #8B451315 3px, transparent 3px)'
      },
    ]
  },
  images: {
    name: 'Hintergrundbilder',
    icon: '🖼️',
    items: [
      { 
        id: 'img-wood-light', 
        type: 'image', 
        value: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=1600&q=80', 
        name: 'Helles Holz',
        thumbnail: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=400&q=60'
      },
      { 
        id: 'img-marble', 
        type: 'image', 
        value: 'https://images.unsplash.com/photo-1615799998603-7c6270a45196?w=1600&q=80', 
        name: 'Marmor',
        thumbnail: 'https://images.unsplash.com/photo-1615799998603-7c6270a45196?w=400&q=60'
      },
      { 
        id: 'img-paper-texture', 
        type: 'image', 
        value: 'https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=1600&q=80', 
        name: 'Papier Textur',
        thumbnail: 'https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=400&q=60'
      },
      { 
        id: 'img-fabric', 
        type: 'image', 
        value: 'https://images.unsplash.com/photo-1604871000636-074fa5117945?w=1600&q=80', 
        name: 'Stoff Textur',
        thumbnail: 'https://images.unsplash.com/photo-1604871000636-074fa5117945?w=400&q=60'
      },
      { 
        id: 'img-concrete', 
        type: 'image', 
        value: 'https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1600&q=80', 
        name: 'Beton hell',
        thumbnail: 'https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=400&q=60'
      },
    ]
  }
};

// Abschnitte der Website die gestylt werden können
export const sectionTypes = [
  { id: 'hero', name: 'Hero-Bereich', description: 'Hauptbereich oben auf der Startseite' },
  { id: 'products', name: 'Produkte-Bereich', description: 'Bereich mit Produkten' },
  { id: 'newsletter', name: 'Newsletter-Bereich', description: 'Newsletter Anmeldung' },
  { id: 'footer', name: 'Footer', description: 'Fußzeile der Seite' },
  { id: 'global', name: 'Global', description: 'Gesamter Hintergrund' },
];

export const getBackgroundStyle = (background) => {
  if (!background) return {};
  
  switch (background.type) {
    case 'solid':
      return { backgroundColor: background.value };
    
    case 'gradient':
      return { background: background.value };
    
    case 'pattern':
      return {
        backgroundColor: background.color || '#F5F5F5',
        backgroundImage: background.value,
        backgroundSize: background.size || '20px 20px',
      };
    
    case 'image':
      return {
        backgroundImage: `url(${background.value})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
    
    default:
      return {};
  }
};

export const getAllBackgrounds = () => {
  return Object.values(backgroundLibrary).flatMap(cat => cat.items);
};

export const getBackgroundsByCategory = (category) => {
  return backgroundLibrary[category]?.items || [];
};
